import styled from 'styled-components'

export const ContainerLaboratory = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  padding: 40px 10px 10px;

  flex-direction: column;
  display: flex;
  gap: 1rem;
`
